import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65946115"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "header" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "grid navigation"
}
const _hoisted_4 = { class: "grid account-and-store-buttons-wrapper" }
const _hoisted_5 = { class: "grid store-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMetaInfo = _resolveComponent("HeaderMetaInfo")!
  const _component_HeaderMenuMobile = _resolveComponent("HeaderMenuMobile")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_HeaderMenu = _resolveComponent("HeaderMenu")!
  const _component_DiscordButton = _resolveComponent("DiscordButton")!
  const _component_StoreBtn = _resolveComponent("StoreBtn")!
  const _component_MenuBtn = _resolveComponent("MenuBtn")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_HeaderMetaInfo),
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_HeaderMenuMobile, {
          key: 0,
          "is-open": _ctx.isMobileMenuOpen,
          onClose: _ctx.closeMobileMenu
        }, null, 8, ["is-open", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Logo),
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_HeaderMenu)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isDesktop)
        ? (_openBlock(), _createBlock(_component_DiscordButton, {
            key: 1,
            class: "discord-button"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StoreBtn)
        ]),
        (_ctx.isMobile)
          ? (_openBlock(), _createBlock(_component_MenuBtn, {
              key: 0,
              ref: "menuButton",
              class: _normalizeClass(["grid", { 'menu-btn--active': _ctx.isMobileMenuOpen }]),
              "is-active": _ctx.isMobileMenuOpen,
              "aria-label": _ctx.$t('mobile_menu.navigation'),
              "aria-controls": "mobile-navigation-drawer",
              "aria-expanded": _ctx.isMobileMenuOpen,
              onClick: _ctx.toggleMobileMenu
            }, null, 8, ["class", "is-active", "aria-label", "aria-expanded", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}